// src/components/SmartBookingRoute.jsx
import React from 'react';
import { useParams, Navigate, useLocation } from 'react-router-dom';
import PublicBookingPage from '../pages/PublicBookingPage';

export default function SmartBookingRoute() {
  const { doctorId } = useParams();
  const location = useLocation();

  const patientToken = localStorage.getItem('patientToken');
  const isGuest = localStorage.getItem('isGuest') === 'true';
  const isPatient = !!patientToken && !isGuest;

  const isPatientPath = location.pathname.startsWith('/patient');

  // Redirecciones inteligentes de ruta:
  // - Si hay sesión de paciente y estás en /book/..., te movemos a /patient/book/...
  if (isPatient && !isPatientPath) {
    return <Navigate to={`/patient/book/${doctorId}`} replace />;
  }
  // - Si NO hay sesión de paciente y estás en /patient/book/..., te movemos a /book/...
  if (!isPatient && isPatientPath) {
    return <Navigate to={`/book/${doctorId}`} replace />;
  }

  // Renderiza la misma página de booking: ella decidirá el formulario (BookingForm vs GuestBookingForm) por ruta
  return <PublicBookingPage />;
}
